import 'whatwg-fetch';

export const getDocumentArrayBuffer = url => {
  // call the server so we can check auth and get our cookies set
  return fetch(url, {
    method: 'GET',
    credentials: 'include',
    mode: 'cors' // no-cors
  })
    .then(response => {
      if (response.status !== 200) {
        return Promise.reject(`Returned code ${response.status}`);
      }
      var contentType = response.headers.get('content-type');
      if (contentType === 'text/html') {
        return Promise.reject('NotAuthenticated');
      }
      return response.arrayBuffer();
    })
    .catch(error => {
      return Promise.reject(error);
    });
};

export const getForms = (client, orderid, isReview) => {
  var host = `https://${client}`;
  if (process.env.NODE_ENV === 'development') {
    host = `http://${client}`;
  }
  return fetch(`${host}/fillableform/${orderid}?isReview=${isReview ? 1 : 0}`, {
    method: 'GET',
    credentials: 'same-origin',
    mode: 'cors' // no-cors
  })
    .then(response => {
      if (response.status !== 200) {
        return Promise.reject('failed not 200');
      }
      return response.json();
    })
    .catch(data => {
      console.log(data);
      return Promise.reject('failed catch');
    });
};
export const getReviewForms = (client, path) => {
  var host = `https://${client}`;
  if (process.env.NODE_ENV === 'development') {
    host = `http://${client}`;
  }
  return fetch(`${host}/${path}`, {
    method: 'GET',
    credentials: 'include',
    mode: 'cors' // no-cors
  })
    .then(response => {
      if (response.status !== 200) {
        return Promise.reject('failed not 200');
      }
      return response.json();
    })
    .catch(data => {
      console.log(data);
      return Promise.reject('failed catch');
    });
};

export const sendFormData = (client, orderid, formData) => {
  var host = `https://${client}`;
  if (process.env.NODE_ENV === 'development') {
    host = `http://${client}`;
  }
  return fetch(`${host}/fillableform/${orderid}`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'text/plain'
    },
    mode: 'cors', // no-cors
    body: JSON.stringify({
      formData
    })
  })
    .then(response => {
      if (response.status !== 200) {
        return Promise.reject('failed not 200');
      }
      return response.json();
    })
    .catch(data => {
      console.log(data);
      return Promise.reject('failed catch');
    });
};

export const getOrder = (client, orderid) => {
  var host = `https://${client}`;
  if (process.env.NODE_ENV === 'development') {
    host = `http://${client}`;
  }
  return fetch(`${host}/exportorder?orderid=${orderid}`, {
    method: 'GET',
    credentials: 'include',
    mode: 'cors' // no-cors
  })
    .then(response => {
      if (response.status !== 200) {
        return Promise.reject('failed not 200');
      }
      return response.json();
    })
    .catch(data => {
      console.log(data);
      return Promise.reject('failed catch');
    });
};

export const checkTosCookie = client => {
  var host = `https://${client}`;
  if (process.env.NODE_ENV === 'development') {
    host = `http://${client}`;
  }
  return fetch(`${host}/signeddoc/termsofuse`, {
    method: 'GET',
    credentials: 'include',
    mode: 'cors' // no-cors
  })
    .then(response => {
      if (response.status !== 200) {
        return Promise.reject('failed not 200');
      }
      return response.json();
    })
    .catch(data => {
      console.log(data);
      return Promise.reject('failed catch');
    });
};

export const setTosCookie = client => {
  var host = `https://${client}`;
  if (process.env.NODE_ENV === 'development') {
    host = `http://${client}`;
  }
  return fetch(`${host}/signeddoc/termsofuse?termsAccepted=1`, {
    method: 'GET',
    credentials: 'include',
    mode: 'cors' // no-cors
  }).then(response => {
    return response;
  });
};

export const getCampaignFormData = (client, engagementId, studentId) => {
  var host = `https://${client}`;
  if (process.env.NODE_ENV === 'development') {
    host = `http://${client}`;
  }
  return fetch(
    `${host}/campaigndata?engagementId=${engagementId}&studentId=${studentId}`,
    {
      method: 'GET',
      credentials: 'include',
      mode: 'cors' // no-cors
    }
  )
    .then(response => {
      console.log('response', response);
      if (response.status !== 200) {
        return Promise.reject('failed not 200');
      }
      return response.json();
    })
    .catch(data => {
      console.log(data);
      return Promise.reject('failed catch');
    });
};
